import React, { useState, useEffect } from "react";

const TimeDisplay = ({ className = "" }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Update every minute

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div className={`text-right leading-tight ${className}`}>
      <div className="text-sm font-medium text-gray-700">
        {formatTime(currentTime)}
      </div>
      <div className="text-[11px] text-gray-400">{formatDate(currentTime)}</div>
    </div>
  );
};

export default TimeDisplay;
